import {Component, OnInit, Self} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from "@ngneat/transloco";
import {LANG, LocalStorageService} from "@services";

@Component({
    selector: 'app-language-picker-modal',
    templateUrl: './language-picker-modal.component.html',
    styleUrl: './language-picker-modal.component.scss',
    providers: [TranslocoService],
    standalone: false
})
export class LanguagePickerModalComponent implements OnInit {

  activeLang?: string;
  selectedLang?: string;

  constructor(public activeModal: NgbActiveModal, @Self() private localTransloco: TranslocoService,
              private translocoService: TranslocoService, private localStorageService: LocalStorageService) {
  }

  ngOnInit(): void {
    this.activeLang = this.translocoService.getActiveLang();
    this.selectedLang = this.translocoService.getActiveLang();
  }

  changeLang(lang: string): void {
    this.activeLang = lang;
    this.localStorageService.saveData(LANG, lang);
    this.translocoService.setActiveLang(lang);
    this.activeModal.dismiss();
    window.location.reload();
  }

  selectLang(lang: string): void {
    this.selectedLang = lang;
    this.localTransloco.setActiveLang(lang);
  }

  onClose(): void {
    this.activeModal.dismiss();
  }

  onSave(): void {

  }
}
